import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { CooldownService } from './cooldown.service';
import { Logger } from '@app/core/logger.service';
import { AnalyticsService } from '@app/shared/services/analytics/analytics.service';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
import { UtilitiesService } from '@app/shared/services/utilities/utilities.service';
import { UpdatePhoneComponent } from '../update-phone/update-phone.component';
import { AlertController, AlertInput, ModalController } from '@ionic/angular';
import { EmailService } from '@app/shared/services/email/email.service';
import { Storage } from '@ionic/storage-angular';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { IonLoaderService } from '@app/shared/services/ion-loader/ion-loader.service';
import { AppComponent } from '@app/app.component';
import { environment } from '@env/environment';
import FIRE from "firebase/compat/app";
import { Browser } from '@capacitor/browser';
import "firebase/auth"
import { Capacitor } from '@capacitor/core';
const log = new Logger('WaitingRoomComponent');
@Component({
  selector: 'app-waiting-room',
  templateUrl: './waiting-room.component.html',
  styleUrls: ['./waiting-room.component.scss']
})
export class WaitingRoomComponent implements OnInit {
  public _validatePerEmail: boolean = false;
  public displayPhone: string;
  public code: string;
  public isLoading: boolean = false;
  public email: string;
  public completed: boolean = false;
  private mobileVerified: boolean;
  private emailVerified: boolean;
  private phone: string;
  private uid: string;
  public attempts: number = 0;
  public nAttempts: number = 3;
  seconds: number = 120; // 2 minutes cooldown

  constructor(
    private router: Router,
    private fireService: FirebaseService,
    private loader: IonLoaderService,
    private alertCtrl: AlertController,
    private utilities: UtilitiesService,
    private authServe: AuthenticationService,
    private analyticsFB: AnalyticsService,
    private modalCtrl: ModalController,
    private emailService: EmailService,
    private storage: Storage,
    private credService: CredentialsService,
    private app: AppComponent,
    public cooldown: CooldownService
  ) {
    this.initializeApp();
  }

  async openWhatsApp(mensaje: string) {
    const url = `https://wa.me/${environment.WHATSAPP_PHONE}?text=${encodeURIComponent(mensaje)}`;
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
      await Browser.open({ url });
    } else {
      window.open(url, '_blank');
    }
    this.updateAttempts();
  }


  private analyticsClickEvent(eventName: string, params: {}) {
    const cred: any = this.credService.credentials;
    const route_page_url: any = this.router.routerState.snapshot.url; // Page route
    this.analyticsFB.logEvent(eventName, params, {
      credentials: cred,
      page_data: { route: route_page_url, title: document.title }
    }); // Analytics LOGS
  }

  private async initializeApp() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      await this.initData();
    } catch (error) {
      log.error('********************* Error *********************', error);
    }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }

  ngOnInit() {
  }

  private async initData() {
    try {
      let authState: firebase.default.User = await this.authServe.getUser();
      if (authState && authState.uid && authState.isAnonymous === false) {
        const complete: boolean = await this.authServe.registrationComplete(authState.uid);
        log.debug(`%cComplete: ${complete}`, 'background-color: blue; font-size: larger; color: white');
        const userData = await this.fireService.afs
          .collection('users')
          .doc(authState.uid)
          .ref.get();
        if (userData.get('type') === 'representante-medico') {
          await this.router.navigate(['/register/representante-medico/complete-registration']).then(async () => {
            return await this.reload();
          });
        }
        if (!complete === true) {
          if (userData.get('type') === 'medico' || userData.get('type') === 'profesional-de-la-salud') {
            await this.router.navigate(['/register/complete-registration']).then(async () => {
              return await this.reload();
            });
          }
        }
        const phoneData = await this.fireService.afs
          .collection('activation-codes')
          .doc(authState.uid)
          .ref.get();
        this.uid = authState.uid;
        this.emailVerified = authState.emailVerified;
        this.email = authState.email;
        this.phone = userData.get('mobile');
        const respLada = userData.get('mobileLada');
        this.displayPhone = this.utilities.getPhone(this.phone, respLada && respLada.lada ? respLada.lada : undefined);
        this.mobileVerified =
          phoneData && phoneData.get('status') && phoneData.get('status') === 'active' ? true : false;
        this.emailVerified = Boolean(this.mobileVerified);
        if (this.mobileVerified === true || this.emailVerified === true) {
          this.completed = true;
          await this.finalize();
        }
      }
      else {
        await this.router.navigate(['/home'], { replaceUrl: true });
      }
      this.attempts = Number((await this.storage.get('connecttimed_verification_code_attempts')) || 0);
    } catch (error) {
      log.error('********************* Error *********************', error);
    }
  }

  private async sendMobileVerification() {
    this.cooldown.startCooldown(this.seconds);
    this._sendMobileVerification();
  }

  private async _sendMobileVerification() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      await this.fireService.sendMobileVerification({ number: this.utilities.normalizeMxNumber(this.phone), uid: this.uid });
      this.utilities.toast('Código enviando correctamente.', 'Reenvío de código telefónico');
    } catch (error) {
      log.error('====== Error ======', error);
    }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }

  private async changePhone() {
    const modal = await this.modalCtrl.create({
      component: UpdatePhoneComponent
    });
    modal.onDidDismiss().then(data => {
      if (data && data.role && data.role === 'updated') {
        this.changePhoneHandler();
      }
    });
    modal.present();
  }

  private async changePhoneHandler() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      this.storage.set('validate_per_email', false);
      this._validatePerEmail = false;
      await this.initializeApp();
      await this.sendMobileVerification();
      this.updateAttempts();
    } catch (error) { }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }

  private async alertError(msg: string) {
    const alert = await this.alertCtrl.create({
      header: 'Ha ocurrido un error',
      message: msg,
      buttons: [
        {
          text: 'Ok'
        }
      ]
    });
    alert.present();
  }

  private async finalize(): Promise<any> {
    try {
      await this.fireService.activateUser(this.uid, false);
      await this.emailService.registerAndWelcome(this.uid);
      this.analyticsClickEvent('click', {
        content_type: 'Finalizado',
        section_name: 'Registro de usuario',
        click_text: 'Finalizar',
        user_type: 'medico'
      });
      await this.router.navigate(['/home/actions/reload'], { replaceUrl: true }).then(async () => {
        return await this.reload();
      });
      return true;
    } catch (error) {
      log.error(error);
    }
  }

  private async reload() {
    const currentUser = await this.authServe.currentUser();
    return await this.app.setUserDataAndCredentials(currentUser);
  }

  private async sendEmailVerification() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const code: string = await this.fireService.code({ type: 'email', uid: this.uid, email: this.email });
      await this.emailService.email({
        recipient: this.email,
        subject: 'Código de Verificación de Cuenta',
        text: `
        <tr>
          <td align="left" class="gr-mltext-euhkjf gr-mltext-bldveo" style="font-size:0px;padding:0;word-break:break-word;">
            <div
              style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:1.5;text-align:left;color:#000000;">
              <div style="text-align: justify">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <br>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="font-size: 18px"><span style="color: #777777"><span
                        style="font-family: Open Sans, Arial, sans-serif">Gracias por registrarse en
                      </span></span><span style="color: #777777"><strong><span
                          style="font-family: Open Sans, Arial, sans-serif">Conectimed</span></strong></span><span
                      style="color: #777777"><span style="font-family: Open Sans, Arial, sans-serif">.</span></span></span>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <br>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="color: #777777"><span style="font-size: 16px"><span
                        style="font-family: Open Sans, Arial, sans-serif">Para completar el proceso
                        de registro</span></span></span>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="font-family: Open Sans, Arial, sans-serif"><span style="color: #777777"><span
                        style="font-size: 16px">verifique su cuenta con
                        el código:</span></span><span style="color: #777777"><strong><span
                          style="font-size: 20px">&nbsp;</span></strong></span><span style="color: #2D88DA"><strong><span
                          style="font-size: 20px"><u>${code}</u></span></strong></span></span>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <br>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="color: #777777"><span style="font-size: 14px"><span
                        style="font-family: Open Sans, Arial, sans-serif">1.Regrese a la aplicación
                        de Conectimed</span></span></span>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="color: #777777"><span style="font-size: 14px"><span
                        style="font-family: Open Sans, Arial, sans-serif">2. Ingrese el código de
                        verificación en el apartado &quot;Validación de
                        Datos&quot;.</span></span></span>
                </p>
              </div>
              <div style="text-align: center">
                <p style="font-family:Arial;font-size:14px;margin-top:0px;margin-bottom:0px;font-weight:normal;color:#000000;">
                  <span style="color: #777777"><span style="font-size: 14px"><span
                        style="font-family: Open Sans, Arial, sans-serif">3. Presione el botón
                        &quot;Continuar&quot; para completar el proceso.</span></span></span>
                </p>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td align="center" style="font-size:0px;padding:24px;word-break:break-word;">
            <p style="border-top:solid 2px #777777;font-size:1px;margin:0px auto;width:80%;"></p><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 2px #777777;font-size:1px;margin:0px auto;width:388.8px;" role="presentation" width="388.8px" ><tr><td style="height:0;line-height:0;"> &nbsp;
                  </td></tr></table><![endif]-->
          </td>
        </tr>
        <tr>
          <td align="center" class="gr-mlimage-jfxauj gr-mlimage-hvqglm" style="font-size:0px;padding:0;word-break:break-word;">
            <table border="0" cellpadding="0" cellspacing="0" role="presentation"
              style="border-collapse:collapse;border-spacing:0px;">
              <tbody>
                <tr>
                  <td style="width:534px;"><img alt=""
                      src="https://us-ms.gr-cdn.com/getresponse-yGxOr/photos/6784516a-e420-43a7-b364-735fc854b00c.jpg"
                      style="border:0;border-left:0 none #000000;border-right:0 none #000000;border-top:0 none #000000;border-bottom:0 none #000000;border-radius:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                      width="534" height="auto"></td>
                </tr>
                <tr>
                  <td>
                    &nbsp;
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td align="center" style="font-size:0px;padding:24px;word-break:break-word;">
            <p style="border-top:solid 0px #ffffff;font-size:1px;margin:0px auto;width:80%;"></p><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 2px #777777;font-size:1px;margin:0px auto;width:388.8px;" role="presentation" width="388.8px" ><tr><td style="height:0;line-height:0;"> &nbsp;
                  </td></tr></table><![endif]-->
          </td>
        </tr>
        `});
      await this.storage.set('first_time_email_send', true);
      this.utilities.toast('Código enviando correctamente.', 'Reenvío de código por email');
    } catch (error) {
      log.error('====== Error ======', error);
    }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }

  private async changeEmail() {
    const alert = await this.alertCtrl.create({
      header: 'Actualizar mi email',
      message: 'A continuación ingrese su contraseña y el nuevo email:',
      inputs: [
        {
          name: 'password',
          type: 'password',
          placeholder: 'Contraseña',
          value: ''
        },
        {
          name: 'email',
          type: 'email',
          placeholder: 'contacto@conectimed.com',
          value: ''
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          cssClass: 'secondary'
        },
        {
          text: 'Actualizar',
          handler: async data => {
            if (data && data.email && data.password) {
              this.changeEmailHandler(data);
            } else {
              this.alertError('Los campos anteriores deben contener información.');
            }
          }
        }
      ]
    });
    await alert.present();
  }

  public async whatsAppAlert(other?: boolean) {
    let buttons: any[] = [
      {
        text: 'Continuar',
        handler: () => {
          this.openWhatsApp(`Tengo problemas para recibir el código para activar mi cuenta. Los datos que ingresé para mi registro son: celular ${this.displayPhone || ''} / email: ${this.email || ''}`);
        }
      },
    ];

    if (other === true) {
      buttons.push({
        text: 'Intentar con otro método',
        handler: () => {
          this._optionsAlert();
        }
      });
    }

    buttons.push({
      text: 'Cancelar',
      cssClass: 'medium-cancel',
    });

    const alert = await this.alertCtrl.create({
      header: 'Iniciar conversación vía WhatsApp',
      message: 'A continuación se le direccionará a WhatsApp para auxiliarle en su proceso de registro. ¿Desea continuar?',
      buttons: buttons
    });

    await alert.present();
  }

  private async changeEmailHandler(data: any) {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const new_email: string = String(data.email)
        .toLocaleLowerCase()
        .trim();
      const email: string = await (await this.authServe.getUser()).email;
      const password: string = data.password;
      const credential = FIRE.auth.EmailAuthProvider.credential(email, password);
      var user = FIRE.auth().currentUser;
      const resp = await user.reauthenticateWithCredential(credential);
      if (resp && resp.user && resp.user.uid) {
        await resp.user.updateEmail(new_email);
        await this.fireService.afs
          .collection('users')
          .doc(resp.user.uid)
          .update({ email: new_email });
        await this.initData();
        this._validatePerEmail = true;
        this.storage.set('validate_per_email', true);
        await this.sendEmailVerification();
        this.cooldown.startCooldown(this.seconds);
        this.updateAttempts();
        this.utilities.toast('Datos actualizados correctamente.', 'Correcto');
      }
    } catch (error: any) {
      if (error && error.code) {
        switch (error.code) {
          case 'auth/wrong-password':
            this.alertError('La contraseña no es válida o el usuario no tiene contraseña.');
            break;
          case 'auth/email-already-in-use':
            this.alertError('El correo que ingreso ya se encuentra asociado a otra cuenta.');
            break;
          case 'auth/invalid-email':
            this.alertError('Ingresa una dirección de correo electrónico válida.');
            break;
          case 'auth/too-many-requests':
            this.alertError(
              'Hemos bloqueado todas las solicitudes de este dispositivo debido a una actividad inusual. Vuelva a intentarlo más tarde.'
            );
            break;
          default:
            this.alertError('Ha ocurrido un error, por favor intentalo mas tarde.');
            break;
        }
      }
      log.error(error.code);
    }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }

  public onCodeChanged(value: string) {
    this.code = value;
  }

  public async optionsAlert() {
    if (this.attempts === this.nAttempts) {
      this.whatsAppAlert(true);
    } else {
      this._optionsAlert();
    }
  }

  public async _optionsAlert() {
    let inputs: AlertInput[] = [
      {
        label: `Enviar a ${this.displayPhone}`,
        type: 'radio',
        checked: true,
        value: 'phone',
      },
      {
        label: `Enviar a ${this.email}`,
        type: 'radio',
        value: 'email',
      },
      {
        label: 'Cambiar de email',
        type: 'radio',
        value: 'change-email',
      },
      {
        label: 'Cambiar de teléfono',
        type: 'radio',
        value: 'change-phone',
      }
    ];
    if (this.attempts >= this.nAttempts) {
      /*
       inputs.splice(2, 0, {
         label: 'Solicitar código por Whatsapp',
         type: 'radio',
         value: 'whatsapp',
       });
      */
    }
    const _alert = await this.alertCtrl.create({
      header: '¿No recibió el código?',
      message: 'Elija a continuación el método al cual desea que reenviemos el código de verificación.',
      inputs,
      buttons: [
        {
          text: 'Cancelar',
          cssClass: 'secondary'
        },
        {
          text: 'Seleccionar',
          handler: async (type) => {
            switch (type) {
              case 'email':
                this._validatePerEmail = true;
                this.storage.set('validate_per_email', true);
                this.sendEmailVerification();
                this.cooldown.startCooldown(this.seconds);
                this.updateAttempts();
                return true;
              case 'phone':
                this.storage.set('validate_per_email', false);
                this._validatePerEmail = false;
                this.sendMobileVerification();
                this.cooldown.startCooldown(this.seconds);
                this.updateAttempts();
                return true;
              case 'change-email':
                this.changeEmail();
                return true;
              case 'change-phone':
                this.changePhone();
                return true;
              case 'whatsapp':
                this.openWhatsApp(`Tengo problemas para recibir el código para activar mi cuenta. Los datos que ingresé para mi registro son: celular ${this.displayPhone || ''} / email: ${this.email || ''}`);
                return true;
              default:
                return false;
            }
          }
        }
      ]
    });
    await _alert.present();
  }

  private updateAttempts() {
    this.attempts++;
    this.storage.set('connecttimed_verification_code_attempts', this.attempts);
  }

  public async codeVerification() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent('Por favor espere, le estamos redirigiendo.', true);
    try {
      const resp = await this.fireService.afs
        .collection('activation-codes')
        .doc<any>(this.uid)
        .ref.get();
      const data = resp.data();
      if (
        data &&
        data.code &&
        String(data.code) === String(this.code)
      ) {
        await this.fireService.afs
          .collection('activation-codes')
          .doc(this.uid)
          .update({ status: 'active' });
        await this.initData();
        await this.utilities.toast('Confirmación de cuenta realizada con éxito.', 'Correcto');
      } else {
        this.alertError(
          'El código ingresado no corresponde con el registrado, por favor revise la información o solicite un nuevo código de verficación.'
        );
      }
    } catch (error) {
      log.error('********************* Error *********************', error);
    }
    this.isLoading = false;
    await this.loader.ionLoaderDismiss();
  }
}
